import AvailableCredit from './available-credit';
import RequestAmount from './request-amount';
import SliderBar from './slider';
const Slider = SliderBar;
const Widget = {
  AvailableCredit,
  RequestAmount,
  Slider
};
export default Widget;
//# sourceMappingURL=index.js.map